<template>
  <div class="p-3 bg-white mx-1">
    <div class="d-flex align-items-center mb-3 pt-2">
      <i class="fas fa-info-circle text-orange fa-lg mr-2" />
      <span class="color-black font-18 font-weight-bold">
        Detalle de Servicios
      </span>
    </div>
    <div
      v-for="(service, si) in services"
      :key="`service-detail-${si}`"
      class="row service-detail-row mx-1 mb-3 pt-3"
    >
      <div class="col-6 col-md-4 pl-0">
        <div class="color-secondary-6 font-14">Tipo de Servicio:</div>
        <div class="color-black font-weight-bold font-14">
          {{ service.serviceTypeName }}
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="color-secondary-6 font-14">Periodo:</div>
        <div class="color-black font-weight-bold font-14">
          {{ service.period }}
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="color-secondary-6 font-14">Costo:</div>
        <div class="color-black font-weight-bold font-14">
          {{ service.costTotalAmt | price }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentStudentServices',
  props: {
    services: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.service-detail-row + .service-detail-row {
  border-top: 1px solid #e9ecef;
}
</style>
